/** Current telemetry precision. Legacy chunks without metadata used 5 seconds. */
export const PLAYBACK_BUCKET_SECONDS = 1;
export const LEGACY_PLAYBACK_BUCKET_SECONDS = 5;
export const PLAYBACK_CHUNK_VERSION = 1;
